<template>
  <div class="search-input-container" @click.stop>
    <div class="input-container">
      <input 
        ref="input" 
        type="text" 
        :placeholder="placeholder" 
        v-model.trim="searchText" 
        @input="searchTermsRecommend" 
        @focus="onSearchInputFocus()" 
        @keypress.enter="onSearch()"
        @keyup.up="onKeyUp"
        @keyup.down="onKeyDown"
      />
      <el-button class="search-button"><i class="icon-search"></i></el-button>
    </div>
    <div v-if="searchText&&isSuggestionPanelActive&&isShowNoDate&&(recommendWordList.length || recommendIssuance.length || recommendOther.length)" class="history-container">
      <div v-if="recommendWordList.length" @mouseover="onMouseOver" @mouseout="isOnMouseOver = false">
        <ul class="suggestion-list" :class="[{ active: isSuggestionPanelActive&&recommendWordList.length&&searchText}]">
          <li 
          class="suggestion-item" 
          :class="{'checked-suggestion-item': checkedCompanyName && item.name === checkedCompanyName.name}"
          v-for="item in recommendWordList" 
          :key="item.index" 
          @click="onSuggestionItemClick(item.name,item.id)">
            <a class="item-value">{{item.name}}</a>
          </li>
        </ul>
      </div>

      <div v-if="recommendIssuance.length">
        <div class="history-title">发债主体</div>
        <ul class="suggestion-list" :class="[{ active: isSuggestionPanelActive&&recommendWordList.length&&searchText}]">
          <li class="suggestion-item" v-for="item in recommendIssuance" :key="item.index" @click="onSuggestionItemClick(item.name,item.id)">
            <a class="item-value">{{item.name}}</a>
          </li>
        </ul>
        <div class="hr-container">
          <div class="hr"></div>
        </div>
      </div>

      <div v-if="recommendOther.length">
        <div class="history-title">其他公司</div>
        <ul class="suggestion-list" :class="[{ active: isSuggestionPanelActive&&recommendWordList.length&&searchText}]">
          <li class="suggestion-item" v-for="item in recommendOther" :key="item.index" @click="onSuggestionItemClick(item.name,item.id)">
            <a class="item-value">{{item.name}}</a>
          </li>
        </ul>
    </div>
    </div>
     <div v-if="searchText&&isSuggestionPanelActive&&isShowNoDate&&!recommendWordList.length&&!recommendIssuance.length&&!recommendOther.length" class="history-container">
      <div class="none-title">没有相关公司</div>
    </div> 
  </div>
</template>

<script>
import arrayHelper from '@/helpers/arrayHelper';
import funcHelper from '@/helpers/funcHelper';
import searchHistoryHelper from '@/helpers/searchHistoryHelper';
import QuestionQuery from '@/rest/questionQuery';

const MAX_SUGGESTION_COUNT = 5;

export default {
  name: 'search-input', 
  props: {
    keyword: String,
    showArrow: Boolean
  },
  data() {
    return {
      active: 'active',
      placeholder: '添加关注公司',
      isSuggestionPanelActive: false,
      searchText: undefined, // used to first time initialization
      historySuggestionList: [], // used to display on the UI
      historySuggestionSet: [], // used to store the whole suggestion list, support maximum 100: TODO
      suggestionList: [],
      recommendWordList: [],
      recommendIssuance: [],
      recommendOther: [],
      timer: null,
      isShowNoDate: false,
      checkedCompanyName: null,
      checkedCompanyNameIndex: -1,
      isOnMouseOver: false
    };
  },
  methods: {
    onKeyUp() {
      if (!this.isOnMouseOver) {
        if (!this.checkedCompanyNameIndex || this.checkedCompanyNameIndex === -1) {
          this.checkedCompanyNameIndex = this.recommendWordList.length - 1;
        } else {
          this.checkedCompanyNameIndex--;
        }
        this.checkedCompanyName = this.recommendWordList[this.checkedCompanyNameIndex];
      }
    },
    onKeyDown() {
      if (!this.isOnMouseOver) {
        if (this.checkedCompanyNameIndex === this.recommendWordList.length - 1) {
          this.checkedCompanyNameIndex = 0;
        } else {
          this.checkedCompanyNameIndex++;
        }
        this.checkedCompanyName = this.recommendWordList[this.checkedCompanyNameIndex];
      }
    },
    onMouseOver() {
      this.checkedCompanyName = null;
      this.checkedCompanyNameIndex = -1;
      this.isOnMouseOver = true;
    },
    searchTermsRecommend() {
      this.isShowNoDate = false;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        if (this.searchText) {
          this.getSearchTextRecommend();
        }
      }, 600);
    },
    async getSearchTextRecommend() {
      const oldSearchText = this.searchText;
      const res = await QuestionQuery.searchTextRecommend(this.searchText);
      if (this.searchText === oldSearchText) {
        this.recommendWordList = res.company;
        this.isSuggestionPanelActive = true;
        this.isShowNoDate = true;
        this.checkedCompanyName = null;
        this.checkedCompanyNameIndex = -1;
      }
    },
    onSearchInputFocus() {
      this.isSuggestionPanelActive = true;
    },
    onSearchInputBlur() {
      this.isSuggestionPanelActive = false;
    },
    onSuggestionItemClick(text, text1) {
      this.searchText = '';
      this.isSuggestionPanelActive = false;
      this.$refs.input.blur();
      this.$emit('onSuggestionItemClick', { name: text, id: text1, type: 'search' });
    },
    onSuggestionHistoryItemClick(text) {
      if (this.suggestionList.indexOf(text) > -1) {
        if (this.suggestionList[this.suggestionList.indexOf(text)].type === 'company') {
          this.$emit('change', text.searchText);
        } else if (this.suggestionList[this.suggestionList.indexOf(text)].type === 'search') {
          this.$emit('searchCompany', text.searchText);
        }
      }
    },
    onSearch() {
      if (this.checkedCompanyName) {
        this.onSuggestionItemClick(this.checkedCompanyName.name, this.checkedCompanyName.id);
      } 
    },
    toCompanyPage() {
      this.isSuggestionPanelActive = false;
      this.$refs.input.blur();
    },
    searchTextChangeHandler(val) {
      this.historySuggestionList = this.filterHistorySuggestionList(val);
      this.suggestionList = this.historySuggestionList;
    },
    filterHistorySuggestionList(query) {
      query = query || '';
      this.historySuggestionSet = searchHistoryHelper.getAll();
      const tmpSuggestionList = this.historySuggestionSet.filter((item) => item.searchText && item.searchText.indexOf(query.toLocaleLowerCase()) > -1); 
      return arrayHelper.takeFirstNElements(tmpSuggestionList, MAX_SUGGESTION_COUNT);    
    }
  },
  mounted() {
    document.addEventListener('click', this.onSearchInputBlur);
    this.searchText = this.keyword || undefined;// to set the same value as it's just mounted
    this.historySuggestionSet = searchHistoryHelper.getAll();
    this.searchTextChangeHandler(this.searchText);
    this.debouncedSearchTextChangeHandler = funcHelper.debounce(this.searchTextChangeHandler, 500);
  },
  beforeDestroy() {
    // un-register events
    if (this.isSuggestionPanelActive) {
      this.onSearchInputBlur();
    }
    document.removeEventListener('click', this.onSearchInputBlur);
  },
  watch: {
    keyword(val) {
      this.searchText = val || '';
    }
  }
};
</script>

<style lang="scss" scoped>
$backgroundColor: #f7f8fc;
$hoverColor: #45a8cc;
$activeColor: #45a8cc;
$color: #747990;

$listItemHoverColor: #747990;
$listItemTextColor: #464d6c;

.search-input-container{
  width: 271px;
  position: relative;
  .input-container {
    position: relative;
    width: 271px;
    input {
      width: 100%;
      height: 26px;
      margin-top: -6px;
      padding: 3px 50px 3px 12px;
      font-size: 14px;
      border: solid 2px $backgroundColor;
      border-radius: 2px;
      background-color: $backgroundColor;
      outline: none;
      color: #747990 ;
    }
    input::-webkit-input-placeholder{
      color: $color;
    }
    input::-moz-placeholder{   /* Mozilla Firefox 19+ */
      color: $color;
    }
    input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
      color: $color;
    }
    input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
      color: $color;
    }

    .search-button { 
      position: absolute;
      top: 5px;
      right: 2px;   
      padding: 0px 12px;
      width: 46px;
      background-color: $backgroundColor;
      border: none;
      cursor: auto;
      span {
        display: block;
      }

      .icon-search {
        display: inline-block;
        width: 14px;
        height: 14px;
        background-image: url('../../assets/img/search2.svg');
        background-size: 100% 100%;
      }
    }
  } 

  .history-container {      
    position: absolute;  
    margin-top: 2px;
    padding: 16px 0 12px;
    width: 271px;
    background-color: #ffffff;
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border: solid 1px #f7f7fa;
    border-radius: 2px;  
    z-index: 1000;

    .suggestion-list {      
      margin: 0;
      padding-left: 0;
      font-size: 14px;
      list-style: none;
      li {
        display: flex;
        justify-content: space-between;
        padding-left: 12px;        
        color: #464d6c; 
        cursor: pointer;

        &:hover {
          background-color: #45a8cc;
          color: #ffffff;
        }

        .item-value {
          overflow: hidden;
          display: inline-block;
          width: 580px;
          height: 28px;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 28px;
        }
        .img {
          margin: 8px 16px 0 0;
          width: 16px;
          height: 16px;
          opacity: 0.2;
          &:hover {
            opacity: 1;
          }
        }
      }
      .checked-suggestion-item {
        background-color: #45a8cc;
        color: #ffffff;
      }
    }

    .history-title {
      padding-left: 12px;
      padding-bottom: 4px;
      font-size: 12px;
      color: #45a8cc;
    }
    .none-title{
      padding-left: 12px;
      font-size: 12px;
      line-height: 28px;
      color: #9ea1b4;
    }
    .hr-container {
      padding: 8px 16px;
      .hr {
        height: 1px;
        background-color: #d8d8d8;
        opacity: 0.1;
      }
    }
  }
    .related-news {
      height: 32px;
      line-height: 32px;
      color: #464d6c;
      background-color: #ffffff !important;
      font-size: 14px; 
      cursor: pointer;
      .related-news-word {
        padding-left: 12px;
      }
    }
}
</style>
